module.exports = __webpack_public_path__ + "static/media/rightAlign.fbbe51b7.svg";